import { render, staticRenderFns } from "./CurrencyList.vue?vue&type=template&id=d88828fc&scoped=true&"
import script from "./CurrencyList.vue?vue&type=script&lang=js&"
export * from "./CurrencyList.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyList.vue?vue&type=style&index=0&id=d88828fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88828fc",
  null
  
)

export default component.exports